import {ChooseMainSourceDataComponent} from './ChooseMainSourceDataComponent';

export default ChooseMainSourceDataComponent;
